/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// SHOW TABBY PRODUCT PAGE SNIPPET ONLY FOR AED

var showTabbySnippet = false;
var selectedCurrencyTabby = "";

if (window.theme.currencyConversionEnabled) {
//     console.log("multi enabled");
    if (document.querySelectorAll('.CurrencySelector__Select').length !== 0) {
//     	console.log("there's a selector");
		selectedCurrencyTabby = document.querySelectorAll('.CurrencySelector__Select')[0].value;
      if (selectedCurrencyTabby === "AED") {
//     	console.log("currency is AED");
         showTabbySnippet = true;
      } else {
//     	console.log("currency is not AED");
      }
    } else {
      // no currency selector, show Tabby
//     	console.log("there's no selector");
      showTabbySnippet = true;
    }

  } else {
    // no multi currency, show Tabby
//     console.log("there's no multi currency");
    showTabbySnippet = true;
}

if (showTabbySnippet) {
//    	console.log("show tabby");
	document.querySelectorAll('.tabby-promo-popup-trigger')[0].style.display = 'flex';
}